
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ProjectStatusSchema', function (Parse) {

		// ==================================================
		// Instantiate Objects
		// ==================================================
		let ProjectStatus = Parse.Object.extend('Project_Status');

		// Define 'ProjectStatus' scheme
		let schema = [
			'status',
			'live'
		];
		
		// Load schema into object prototype
		schema.forEach(function (field) {
			Object.defineProperty(ProjectStatus.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return ProjectStatus;

	});
}




// WEBPACK FOOTER //
// ./src/app/core/schemas/project-status.schema.js